import moment from 'moment'
import {formatter} from './FormatFee'

export const FormateContractPayment = (data: any) => {
  let arr: any = []
  if (data && data.length > 0) {
    data.map((o: any, i: number) => {
      o.id = i + 1
      if (o.date) {
        o.date = moment(o.date, 'DD/MM/YYYY').toDate()
      }
      if (o.money && o.oldMoney) o.moneyDiff = formatter(o.money - o.oldMoney)
      else o.moneyDiff = '0'
      if (o.money) o.money = formatter(o.money)
        
    })
    arr = data
  }
  return arr
}
